import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class OfferRequestItems {
  constructor($scope, OfferRequestService, FileUploader, GeoService) {
    function load_data(selected_items, item_key) {
      OfferRequestService.get_offer_request_items($scope.offer_request.id).success(function(data) {
        $scope.items = data.items;
        console.log(data.items);
        $scope.fields = data.fields;
        $scope.request_fields = data.request_fields;
        $scope.quantity_type = data.quantity_type;
        if (selected_items) {
          _.each($scope.items, function(item) {
            item.checked = _.contains(selected_items, item[item_key]);
          });
        }
        $scope.order_confirmations = [];
        _.each(data.order_confirmations, function(c) {
          var order_confirmation = {
            id: c.id,
            doc_details: c.doc_details,
            doc_specs: c.doc_specs,
            order_id: c.order_id,
            show_offer_info: c.show_offer_info,
            show_item_prices: c.show_item_prices,
            notifications: c.notifications,
            items: []
          };
          _.each(c.items.items, function(i) {
            order_confirmation.items.push(_.findWhere($scope.items, {
              id: i
            }));
          });
          $scope.order_confirmations.push(order_confirmation);
        });
        $scope.$broadcast('update_offer_request_item_tabs', {});
      });
    }

    function load_details() {
      OfferRequestService.get_details_data().success(function(data) {
        $scope.delivery_terms = data.delivery_terms;
        $scope.delivery_methods = data.delivery_methods;
        $scope.payment_terms = data.payment_terms;
        $scope.currency_symbols = data.currency_symbols;
        $scope.quantity_types = data.quantity_types;
        $scope.layout_texts = data.layout_texts;
        $scope.series_texts = data.series_texts;
      });
    }

    function set_uploaders() {
      var uploaders = [{
        name: 'items_uploader',
        url: '/admin/marketplace/offer_requests/import_items/' + window.offer_request.id,
        element: 'items_file'
      }];
      _.each(uploaders, function(uploader) {
        var f = new FileUploader({
          url: uploader.url,
          formData: [{
            authenticity_token: window.token
          }],
          removeAfterUpload: true
        });
        f.file_element = uploader.element;
        f.onBeforeUploadItem = function(/*item*/) {
          f.processing = true;
        };
        f.onCompleteItem = function(fileItem, response/*, status, headers*/) {
          if (response.success) {
            f.processing = false;
            f.clearQueue();
            $('input.' + f.file_element).val(null);
            load_data();
          }
        };
        $scope[uploader.name] = f;
      });
    }

    function get_buyer_address_options() {
      return {
        consignee_address: false,
        notify_address: false,
        docs_address: false
      };
    }

    $scope.$on('load_items', function(event, data) {
      load_data(data ? data.selected_items : [], data ? data.item_key : null);
    });

    $scope.$watch('offer_request.shipment_country_id', function() {
      if ($scope.offer_request && $scope.offer_request.shipment_country_id) {
        GeoService.get_cities($scope.offer_request.shipment_country_id).then(function(data) {
          $scope.shipment_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.offer_request.shipment_city_id}))
            $scope.offer_request.shipment_city_id = null;
        });
      }
    });

    $scope.$watch('offer_request.delivery_country_id', function() {
      if ($scope.offer_request && $scope.offer_request.delivery_country_id) {
        GeoService.get_cities($scope.offer_request.delivery_country_id).then(function(data) {
          $scope.delivery_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.offer_request.delivery_city_id}))
            $scope.offer_request.delivery_city_id = null;
        });
      }
    });
    
    $scope.$watch('offer_request.sc_series', function() {
      OfferRequestService.get_next_sc_id($scope.offer_request.id,$scope.offer_request.sc_series).then(function(data) {
        $scope.next_sc_id = data.data.sc_id;
      });
    });

    $scope.update_details = function() {
      var details = {
        id: $scope.offer_request.id,
        delivery_term_id: $scope.offer_request.delivery_term_id,
        shipment_country_id: $scope.offer_request.shipment_country_id,
        shipment_city_id: $scope.offer_request.shipment_city_id,
        delivery_country_id: $scope.offer_request.delivery_country_id,
        delivery_city_id: $scope.offer_request.delivery_city_id,
        origin_of_goods: $scope.offer_request.origin_of_goods,
        delivered_by: $scope.offer_request.delivered_by,
        acceptable_payment_term_id: $scope.offer_request.acceptable_payment_term_id,
        remarks: $scope.offer_request.remarks,
        buyer_address_options: $scope.offer_request.buyer_address_options,
        has_insurance: $scope.offer_request.has_insurance,
        currency_symbol: $scope.offer_request.currency_symbol,
        quantity_type: $scope.offer_request.quantity_type,
        commission_unit: $scope.offer_request.commission_unit,
        comments: $scope.offer_request.comments,
        layout: $scope.offer_request.layout,
        sc_series: $scope.offer_request.sc_series
      };
      $scope.updating_details = true;
      OfferRequestService.update(details).success(function(data) {
        if (data.success)
          $scope.updating_details = false;
      });
    };

    $scope.update_basic_info = function() {
      var info = {
        id: $scope.offer_request.id,
        title: $scope.offer_request.title,
        status: $scope.offer_request.status,
        order_id: $scope.offer_request.order_id
      };
      $scope.updating_basic_info = true;
      OfferRequestService.update(info).success(function(data) {
        if (data.success)
          $scope.updating_basic_info = false;
      });
    };

    $scope.$on('publish_data', function(event, data) {
      $scope.buyer = data;
    });

    $scope.update_buyer_details = function() {
      $scope.updating_buyer_details = true;
      var details = {
        id: window.offer_request.id,
        buyer_details: $scope.buyer
      };
      OfferRequestService.update(details).success(function(data) {
        if (data.success)
          $scope.updating_buyer_details = false;
      });
    };

    $scope.init = function() {
      $scope.offer_request = window.offer_request;
      if (!$scope.offer_request.buyer_address_options)
        $scope.offer_request.buyer_address_options = get_buyer_address_options();
      $scope.countries = angular.copy(window.countries);
      $scope.items = [];
      $scope.status_options = OfferRequestService.get_status_options();
      set_uploaders();
      load_data();
      load_details();
    };

    $scope.init();
  }
}

OfferRequestItems.$inject = ['$scope', 'OfferRequestService', 'FileUploader', 'GeoService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-request-items.ctrl.js